module.exports = __webpack_public_path__ + "media/step8_animation.5c76fa21.mp4";